import ResourcesCollectionProto from "./resources-collection-proto"
import Resources from "../resources";
import Dependency from "../../model2/dependency/dependency";

export default class DependenciesResourcesCollection extends ResourcesCollectionProto {

    constructor(resources:Resources, data: any[] = [], options:any = {}) {
        super(resources, data, Dependency, options)
    }


    // linkTasks(tasksCollection: TasksResourcesCollection | null) {
    //
    //     if (!tasksCollection) return
    //
    //     _.map(this.models, (timeReport)=>{
    //         timeReport.task = tasksCollection.get(timeReport.taskId)
    //     })
    //
    // }
}